/****************************************************
 * Module Name:  workersettingsProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class WorkersettingsProxy {
  static GetAllWorkersettings = (callback) => {
    restAPICall(
      Constants.WORKER_URL + "/setting",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleWorkersetting = (settingKey, callback) => {
    let params = {
      setting: settingKey,
    };

    restAPICall(
      Constants.WORKER_URL + "/setting",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckWorkersettingsAvailable = (setting, callback) => {
    let params = {
      setting: setting,
    };

    restAPICall(
      Constants.WORKER_URL + "/setting/available",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddWorkersettings = (setting, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/setting",
      "post",
      undefined,
      undefined,
      JSON.stringify(setting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateWorkersettings = (setting, callback) => {
    restAPICall(
      Constants.WORKER_URL + "/setting",
      "put",
      undefined,
      undefined,
      JSON.stringify(setting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
